module.exports = __webpack_public_path__ + "static/media/dropdown-icon-selected.b875d4cc.svg";